import {
  blue,
  green,
  purple,
  orange,
  grey,
} from "@mui/material/colors";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import * as DefaultRoutes from "@Routes/DefaultRoutes";
import GenericHomePage from "@Pages/GenericHomePage/GenericHomePage";
import EditCalendarRoundedIcon from "@mui/icons-material/EditCalendarRounded";
import MarkEmailUnreadRoundedIcon from "@mui/icons-material/MarkEmailUnreadRounded";
import FactCheckRoundedIcon from "@mui/icons-material/FactCheckRounded";
import FolderCopyRoundedIcon from '@mui/icons-material/FolderCopyRounded';
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import DriveFileMoveRoundedIcon from '@mui/icons-material/DriveFileMoveRounded';
import MoreTimeIcon from '@mui/icons-material/MoreTime';


const RnDMemberHome = () => {
  const navigate = useNavigate();
  const theme = useTheme();

  const sectionsBox = [
    {
      textBeside: "Incoming Exit Requests",
      icon: MarkEmailUnreadRoundedIcon,
      iconColor: blue[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: blue[100],
      onClick: () => navigate(DefaultRoutes.rdIncomingRequests),
    },
    {
      textBeside: "My Impact Assessments",
      icon: FactCheckRoundedIcon,
      iconColor: grey[600],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: grey[200],
      onClick: () => navigate(DefaultRoutes.rdResponses),
    },
    {
      textBeside: "Exit Plans",
      icon: EditCalendarRoundedIcon,
      iconColor: purple[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: purple[100],
      onClick: () => navigate(DefaultRoutes.rdExitPlans),
    },
    {
      textBeside: "My Regulatory Exemptions",
      icon: ReceiptLongIcon,
      iconColor: orange[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: orange[100],
      onClick: () => navigate(DefaultRoutes.rdExemptions),
    },
    {
      textBeside: "Regulatory Ingredients Hub",
      icon: FolderCopyRoundedIcon,
      iconColor: green[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: green[100],
      onClick: () => navigate(DefaultRoutes.activeReqs),
    },    {
      textBeside: "Delegation Requests",
      icon: DriveFileMoveRoundedIcon,
      iconColor: grey[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: grey[100],
      onClick: () => navigate(DefaultRoutes.rdDelegationRequests),
    },
    {
      textBeside: "Extension Requests",
      icon: MoreTimeIcon,
      iconColor: purple[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: purple[100],
      size: 4,
      onClick: () => navigate(DefaultRoutes.rdExtensionRequests),
    },
  ];

  return <GenericHomePage sectionsBox={sectionsBox} />;
};

export default RnDMemberHome;
